import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GroupPayorMappingRoutingModule } from './group-payor-mapping-routing.module';
import { GroupPayorMappingComponent } from './group-payor-mapping.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { TransactionDataMenuService } from '../transaction-menu/transaction-menu.dataservice';
import { GroupPayorMappingService } from './group-payor-mapping.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';


@NgModule({
  declarations: [GroupPayorMappingComponent],
  imports: [
    CommonModule,
    GroupPayorMappingRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaskedTextBoxModule,
    GridModule,
    NgSelectModule,
    NgxUiLoaderModule,
    DropDownListAllModule
  ],
  schemas:[NO_ERRORS_SCHEMA],
  providers:[ColumnChooserService,PageService,SortService,FilterService, ResizeService,TransactionDataMenuService,GroupPayorMappingService],
})
export class GroupPayorMappingModule { }
